import { render, staticRenderFns } from "./footer-layout.vue?vue&type=template&id=3b541870&scoped=true&"
import script from "./footer-layout.vue?vue&type=script&lang=js&"
export * from "./footer-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b541870",
  null
  
)

export default component.exports